import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, TicketStatus } from './index';
import { PaginationProps } from '../types';

export type TicketListData = AnyObject

export type TicketListResponse = TicketListData
export type TicketListColumns = 'id' |
  'name' |
  'type' |
  'createdAt' |
  'updatedAt';

export type TicketListGetParams = PaginationProps<TicketListColumns> & {
  search?: string;
  name?: string;
  type?: string;
  user?: string;
  status?: TicketStatus | null;
  updatedAtStart?: string;
  updatedAtEnd?: string;
}

export const ticketListGet = (payload: TicketListGetParams): Action<TicketListGetParams> => ({
  type: actions.ticketListTrigger.toString(),
  payload,
});

export const ticketListClear = (): Action => ({
  type: actions.ticketListClear.toString(),
});

export function* ticketListRequestSaga({ payload }: Action<TicketListGetParams>) {
  yield put({
    type: actions.ticketListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.ticketListError.toString(),
      payload: {
        message: 'TicketList: Parameters not passed.',
      },
    });

    return;
  }

  const params = new URLSearchParams(Object.entries(payload).filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/tickets?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TicketListData, TicketListResponse>(
    response,
    actions.ticketListSuccess.toString(),
    actions.ticketListError.toString(),
    false,
    (ticketListData) => ticketListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.ticketListTrigger.toString(),
    defaultProcessingSaga(
      ticketListRequestSaga,
      {
        error: actions.ticketListError.toString(),
        locationCancel: actions.ticketListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.ticketListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.ticketListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.ticketListErrorReset.toString(),
    });
  });
}
